<template>
  <div class="row" v-if="$gate.isAdmin()">
    <!-- Toolbar -->
    <div class="toolbar py-6">
        <div class="container-fluid d-flex align-items-center">
            <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
                    <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
                        <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a></li>
                        <li class="breadcrumb-item pe-3 text-muted">Tipuri abonamente</li>
                    </ol>
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
            </div>
        </div>
    </div>

    <!-- Content -->

    <div class="content d-flex flex-column flex-column-fluid">
        <div class="container-fluid">
            <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                    <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
                        <div class="input-group w-250px">
                            .
                        </div>
                        <div class="w-100 mw-150px">
                            .
                        </div>
                        <a class="btn btn-primary" @click="modalAdaugareAbonament()">Adaugă abonament</a>
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div id="tabel_abonamente_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="table-responsive w-100">
                        <table class="table table-striped table-row-bordered gy-5 gs-7 w-100" role="grid" id="tabel_abonamente">
                        <thead>
                            <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                            <th class="w-5px pe-2 sorting" rowspan="1" colspan="1" aria-label="" style="width: 10.8906px;"></th>
                            <th class="min-w-10px sorting" tabindex="0">ID</th>
                            <th class="min-w-180px sorting" tabindex="0">Denumire</th>
                            <th class="min-w-250px sorting" tabindex="0">Descriere</th>
                            <th class="min-w-100px sorting" tabindex="0">Preț lunar</th>
                            <th class="min-w-100px sorting" tabindex="0">Preț anual</th>
                            <th class="min-w-80px sorting" tabindex="0">Activ</th>
                            <th class="text-end min-w-120px sorting" tabindex="0">Modificat la</th>
                            <th class="text-end min-w-120px" tabindex="0">Acțiuni</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="a in abonamente" :key="a.id">
                            <td>
                                <div class="form-check form-check-sm form-check-custom form-check-solid">
                                <input class="form-check-input" type="checkbox" :value="a.id">
                                </div>
                            </td>
                            <td data-kt-ecommerce-order-filter="order_id">
                                <a class="text-gray-800 text-hover-primary fw-bold">{{ a.id }}</a>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">{{ a.denumire }}</div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                <span :title="stripHtml(a.descriere)">{{ shortDescriere(a.descriere) }}</span>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                <div class="badge badge-light-primary fs-6 py-3 px-4">{{ Number(a.pret_lunar || 0).toFixed(2) }} lei</div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                <div class="badge badge-light-success fs-6 py-3 px-4">{{ Number(a.pret_anual || 0).toFixed(2) }} lei</div>
                                </div>
                            </td>
                            <td>
                                <span :class="a.activ ? 'badge badge-light-success fs-6 py-3 px-4' : 'badge badge-light-danger fs-6 py-3 px-4'">{{ a.activ ? 'Activ' : 'Inactiv' }}</span>
                            </td>
                            <td class="text-end">
                                <span class="fw-bold" v-if="a.updated_at">{{ $filters.formatDate(a.updated_at) }}</span>
                                <span class="fw-bold" v-else>-</span>
                            </td>
                            <td class="text-end">
                                <button type="button" class="btn btn-warning" @click="modalEditareAbonament(a)">Editare</button>
                            </td>
                            </tr>
                        </tbody>

                        </table>
                    </div>
                    </div>
                </div>
            </div>
      </div>
    </div>

    <!-- Modal Adăugare/Editare abonament -->
    <div class="modal fade" id="abonamenteModal" role="dialog" aria-labelledby="abonamenteModalLabel">
      <div class="modal-dialog modal-xl modal-custom-width">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" v-show="!editmode" id="abonamenteModalLabel">Adăugare abonament</h3>
            <h3 class="modal-title" v-show="editmode" id="abonamenteModalLabel">Editează abonament</h3>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <form onsubmit="return false;">
              <div class="container-fluid">
                <div id="abonamente">
                  <div class="row g-5">
                    <div class="col-md-6">
                      <div class="form-floating mb-7">
                        <input type="text" v-model="form.denumire" class="form-control" id="denumire"/>
                        <label for="denumire">Denumire abonament</label>
                      </div>

                      <div class="mb-5">
                        <label class="form-label">Descriere abonament</label>
                        <VueEditor v-model="form.descriere"></VueEditor>
                        <div class="text-muted fs-7">Descriere HTML / text.</div>
                      </div>

                      <div class="mb-5">
                        <label class="form-label">Opțiuni (JSON)</label>
                        <textarea class="form-control" rows="6" v-model="form.optiuni_json" placeholder='ex: {"facturi":true,"export_pdf":true}'></textarea>
                        <div class="text-muted fs-7">
                          Chei/valori pentru funcționalități (salvate în câmpul <code>optiuni</code>).
                        </div>
                      </div>

                      <div class="mb-5">
                        <label class="form-label">Alte informații</label>
                        <VueEditor v-model="form.alte_informatii"></VueEditor>
                      </div>

                      <div class="form-floating mb-7">
                        <textarea v-model="form.observatii" class="form-control" id="observatii" style="height: 120px;"></textarea>
                        <label for="observatii">Observații</label>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="input-group mb-5">
                        <span class="input-group-text">Preț lunar</span>
                        <input type="number" step="0.01" class="form-control" v-model.number="form.pret_lunar" placeholder="0.00"/>
                        <span class="input-group-text">lei</span>
                      </div>

                      <div class="input-group mb-5">
                        <span class="input-group-text">Preț anual</span>
                        <input type="number" step="0.01" class="form-control" v-model.number="form.pret_anual" placeholder="0.00"/>
                        <span class="input-group-text">lei</span>
                      </div>

                      <div class="form-check form-switch mb-7">
                        <input class="form-check-input" type="checkbox" v-model="form.activ" id="activ">
                        <label class="form-check-label" for="activ">Activ</label>
                      </div>

                      <div class="form-floating mb-7">
                        <input type="text" v-model="form.created_at" class="form-control" id="created_at" readonly/>
                        <label for="created_at">Adăugat la</label>
                      </div>

                      <div class="form-floating mb-7">
                        <input type="text" v-model="form.updated_at" class="form-control" id="updated_at" readonly/>
                        <label for="updated_at">Actualizat la</label>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Închide</button>
            <button @click="actualizeazaAbonamente()" v-show="editmode" type="submit" class="btn btn-success">Modifică</button>
            <button v-show="!editmode" @click="adaugaAbonament()" type="submit" class="btn btn-primary">Adaugă</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";

export default {
  components: { moment },
  data () {
    return {
      setari_select2: {
        theme: "bootstrap",
        placeholder: "Selectează din listă",
        width: "100%",
      },

      abonamente: [],
      editmode: false,

      form: Form.make({
        id: '',
        denumire: '',
        descriere: '',
        optiuni_json: '',
        alte_informatii: '',
        pret_lunar: 0,
        pret_anual: 0,
        observatii: '',
        activ: 1,
        created_at: '',
        updated_at: '',
      }),
    }
  },
  methods:{
    stripHtml(html) {
      if (!html) return '';
      return String(html).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    },
    shortDescriere(html) {
      const txt = this.stripHtml(html);
      return txt.length > 120 ? txt.slice(0, 117) + '…' : txt;
    },

    incarcaAbonamente(){
      axios.get("/api/administrare/abonamente")
        .then((response) => {
          this.abonamente = response.data;
          $(document).ready(function () {
            $('#tabel_abonamente').DataTable().destroy();
            $('#tabel_abonamente').DataTable({
                order: [[1, 'desc']], // sortare dupa ID desc
                data: this.abonamente,
                dom: 'Bfrtip',
                buttons:['disable'],
                language: {
                url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json'
                }
            });
        });
        });
    },

    modalAdaugareAbonament(){
      this.editmode = false;
      this.form.reset();
      $('#abonamenteModal').modal('show');
    },

    modalEditareAbonament(a){
      this.editmode = true;
      this.form.reset();
      const payload = {
        id: a.id,
        denumire: a.denumire || '',
        descriere: a.descriere || '',
        optiuni_json: a.optiuni ? JSON.stringify(a.optiuni, null, 2) : (a.optiuni_json || ''),
        alte_informatii: a.alte_informatii || '',
        pret_lunar: Number(a.pret_lunar || 0),
        pret_anual: Number(a.pret_anual || 0),
        observatii: a.observatii || '',
        activ: a.activ ? 1 : 0,
        created_at: a.created_at || '',
        updated_at: a.updated_at || '',
      };
      this.form.fill(payload);
      $('#abonamenteModal').modal('show');
    },

    adaugaAbonament(){
      this.$Progress.start();
      const payload = { ...this.form.data() };
      payload.activ = this.form.activ ? 1 : 0;
      try {
        payload.optiuni = this.form.optiuni_json ? JSON.stringify(JSON.parse(this.form.optiuni_json)) : null;
      } catch (e) {
        payload.optiuni = this.form.optiuni_json || null;
      }
      delete payload.optiuni_json;
      payload.pret_lunar = Number(payload.pret_lunar || 0);
      payload.pret_anual = Number(payload.pret_anual || 0);

      axios.post('/api/administrare/abonamente', payload)
        .then(()=>{
          toast.fire({ position: 'top-end', icon: 'success', title: 'Abonament adăugat!', showConfirmButton: false, timer: 1200 })
          emitter.emit('AfterCreate');
          this.$Progress.finish();
          $('#abonamenteModal').modal('hide');
        })
        .catch((e)=>{
          this.$Progress.fail();
          const msgs = [];
          const resp = e && e.response ? e.response.data : null;
          if (resp) {
            if (resp.message) msgs.push(resp.message);
            if (resp.errors) Object.values(resp.errors).forEach(v => Array.isArray(v) ? v.forEach(m=>msgs.push(m)) : msgs.push(v));
          }
          const unique = Array.from(new Set(msgs.map(m=>String(m).trim())));
          toast.fire({ position: 'top-end', icon: 'warning', title: 'Eroare la adăugare', text: unique.slice(0,5).join('\n'), showConfirmButton: false, timer: 2500 })
        });
    },

    actualizeazaAbonamente(){
      this.$Progress.start();
      const payload = { ...this.form.data() };
      payload.activ = this.form.activ ? 1 : 0;
      try {
        payload.optiuni = this.form.optiuni_json ? JSON.stringify(JSON.parse(this.form.optiuni_json)) : null;
      } catch (e) {
        payload.optiuni = this.form.optiuni_json || null;
      }
      delete payload.optiuni_json;
      payload.pret_lunar = Number(payload.pret_lunar || 0);
      payload.pret_anual = Number(payload.pret_anual || 0);

      axios.put('/api/administrare/abonamente/'+this.form.id, payload)
        .then(()=>{
          swal.fire({ position: 'top-end', icon: 'success', title: 'Abonament actualizat!', showConfirmButton: false, timer: 1200 })
          emitter.emit('AfterCreate');
          this.$Progress.finish();
          $('#abonamenteModal').modal('hide');
        })
        .catch((e)=>{
          this.$Progress.fail();
          const msgs = [];
          const resp = e && e.response ? e.response.data : null;
          if (resp) {
            if (resp.message) msgs.push(resp.message);
            if (resp.errors) Object.values(resp.errors).forEach(v => Array.isArray(v) ? v.forEach(m=>msgs.push(m)) : msgs.push(v));
          }
          const unique = Array.from(new Set(msgs.map(m=>String(m).trim())));
          toast.fire({ position: 'top-end', icon: 'warning', title: 'Eroare la actualizare', text: unique.slice(0,5).join('\n'), showConfirmButton: false, timer: 2500 })
        });
    },
  },
  computed: {},
  created(){
    // căutare globală (lăsat cum era)
    emitter.on('searching', () => {
      let query = this.$parent.search;
      axios.get('/api/utile/cautareDosare?cD=' + query)
        .then((data)=>{ this.dosare = data.data })
        .catch(()=>{ console.log('eroare la cautare'); })
    });

    this.incarcaAbonamente();

    emitter.on('AfterCreate', () => {
      const t = $('#tabel_abonamente').DataTable();
      if (t) { t.destroy(); }
      this.incarcaAbonamente();
    });
  },
}
</script>

<style lang="scss" scoped>
.icon-mare { font-size: 24px }
.modal-custom-width { max-width: 85% !important; }

</style>